/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/
import theme from './themes/theme'

const getOrderStatusColor = (status) =>{
    if (status === 'pendiente') return 'orange'
    else if (status === 'pagado') return 'green'
    else if (status === 'declinado') return 'red'
    else if (status === 'referenciado') return 'blue'
    else if (status === 'cancelado' || status === 'vencido') return 'grey'
}

const getOrderStatusIcon = (status) => {
    if (status === 'pendiente') return 'fas fa-clock'
    else if (status === 'pagado') return 'fas fa-check-circle'
    else if (status === 'declinado') return 'fas fa-credit-card'
    else if (status === 'referenciado') return 'fas fa-file-invoice-dollar'
    else if (status === 'cancelado') return 'fas fa-trash'
    else if (status === 'vencido') return 'fas fa-calendar-times'
}

const getProcedureStatusColor = (status) =>{
    if (status === 'active') return 'status_active' //'#f15a25'
    else if (status === 'in-process') return 'status_process' //'#239cd3'
    else if (status === 'finished') return 'status_finished' //'#72bc41'
    else if (status === 'canceled' || status === 'deleted') return 'status_canceled'
}

const getProcedureStatusIcon = (status) =>{
    if (status === 'active') return 'ico_status_pendiente'
    else if (status === 'in-process') return 'ico_status_proceso'
    else if (status === 'finished') return 'ico_status_terminado'
    else if (status === 'canceled' || status === 'deleted') return 'fas fa-trash'
}

const renderImageFromAssets = (imagePath) => {
    return require('@/assets/'+theme.icons[imagePath])
}

export {
    getOrderStatusColor,
    getOrderStatusIcon,
    getProcedureStatusColor,
    getProcedureStatusIcon,
    renderImageFromAssets
}